var React = require('react');

function List (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M1 5c0-.5.4-1 .8-1s.8.5.8 1c0 .3-.4.7-.8.7S1 5.3 1 5zm3 0c0-.5.3-1 .8-1h9.5c.4 0 .7.5.7 1 0 .3-.3.7-.7.7H4.8c-.5 0-.8-.4-.8-.8zM1 8c0-.4.4-.8.8-.8s.8.4.8.8-.4.8-.8.8S1 8.4 1 8zm3 0c0-.4.3-.8.8-.8h9.5c.4 0 .7.4.7.8s-.3.8-.7.8H4.8c-.5 0-.8-.4-.8-.8zm-3 3c0-.3.4-.7.8-.7s.8.4.8.8c0 .6-.4 1-.8 1s-.8-.4-.8-1zm3 0c0-.3.3-.7.8-.7h9.5c.4 0 .7.4.7.8 0 .6-.3 1-.7 1H4.8c-.5 0-.8-.4-.8-1z"}));
}

List.defaultProps = {"width":"50","height":"50","viewBox":"0 0 16 16"};

module.exports = List;

List.default = List;
